import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10bfd5ae"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10bfd5ae')) {
      api.createRecord('10bfd5ae', component.options)
    } else {
      api.reload('10bfd5ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10bfd5ae", function () {
      api.rerender('10bfd5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/reportes/botones_campanas/index.vue"
export default component.exports